import ceskaPostaBalikDoRukyFallback from '@/assets/images/transports-payments/ceska-posta-balik-do-ruky.png?w=100'
import ceskaPostaBalikDoRukyAvif from '@/assets/images/transports-payments/ceska-posta-balik-do-ruky.png?w=100&format=avif&as=srcset'
import ceskaPostaBalikDoRukyWebp from '@/assets/images/transports-payments/ceska-posta-balik-do-ruky.png?w=100&format=webp&as=srcset'
import dhlExpressFallback from '@/assets/images/transports-payments/dhl-express.png?w=100'
import dhlExpressAvif from '@/assets/images/transports-payments/dhl-express.png?w=100&format=avif&as=srcset'
import dhlExpressWebp from '@/assets/images/transports-payments/dhl-express.png?w=100&format=webp&as=srcset'
import fanCourierFallback from '@/assets/images/transports-payments/fan_courier.png?w=100'
import fanCourierAvif from '@/assets/images/transports-payments/fan_courier.png?w=100&format=avif&as=srcset'
import fanCourierWebp from '@/assets/images/transports-payments/fan_courier.png?w=100&format=webp&as=srcset'
import geisFallback from '@/assets/images/transports-payments/geis.png?w=100'
import geisAvif from '@/assets/images/transports-payments/geis.png?w=100&format=avif&as=srcset'
import geisWebp from '@/assets/images/transports-payments/geis.png?w=100&format=webp&as=srcset'
import glsFallback from '@/assets/images/transports-payments/gls.png?w=100'
import glsAvif from '@/assets/images/transports-payments/gls.png?w=100&format=avif&as=srcset'
import glsWebp from '@/assets/images/transports-payments/gls.png?w=100&format=webp&as=srcset'
import glsParcelFallback from '@/assets/images/transports-payments/gls-parcel.png?w=100'
import glsParcelAvif from '@/assets/images/transports-payments/gls-parcel.png?w=100&format=avif&as=srcset'
import glsParcelWebp from '@/assets/images/transports-payments/gls-parcel.png?w=100&format=webp&as=srcset'
import osobniOdberFallback from '@/assets/images/transports-payments/osobni-odber.png?w=100'
import osobniOdberAvif from '@/assets/images/transports-payments/osobni-odber.png?w=100&format=avif&as=srcset'
import osobniOdberWebp from '@/assets/images/transports-payments/osobni-odber.png?w=100&format=webp&as=srcset'
import paczkomatFallback from '@/assets/images/transports-payments/paczkomat_pl.png?w=100'
import paczkomatAvif from '@/assets/images/transports-payments/paczkomat_pl.png?w=100&format=avif&as=srcset'
import paczkomatWebp from '@/assets/images/transports-payments/paczkomat_pl.png?w=100&format=webp&as=srcset'
import pplFallback from '@/assets/images/transports-payments/ppl.png?w=100'
import pplAvif from '@/assets/images/transports-payments/ppl.png?w=100&format=avif&as=srcset'
import pplWebp from '@/assets/images/transports-payments/ppl.png?w=100&format=webp&as=srcset'
import pplParcelShopFallback from '@/assets/images/transports-payments/ppl-parcel-shop.png?w=100'
import pplParcelShopAvif from '@/assets/images/transports-payments/ppl-parcel-shop.png?w=100&format=avif&as=srcset'
import pplParcelShopWebp from '@/assets/images/transports-payments/ppl-parcel-shop.png?w=100&format=webp&as=srcset'
import pplParcelShopSkFallback from '@/assets/images/transports-payments/ppl-parcel-shop-SK.png?w=100'
import pplParcelShopSkAvif from '@/assets/images/transports-payments/ppl-parcel-shop-SK.png?w=100&format=avif&as=srcset'
import pplParcelShopSkWebp from '@/assets/images/transports-payments/ppl-parcel-shop-SK.png?w=100&format=webp&as=srcset'
import zasilkovnaFallback from '@/assets/images/transports-payments/zasilkovna.png?w=100'
import zasilkovnaAvif from '@/assets/images/transports-payments/zasilkovna.png?w=100&format=avif&as=srcset'
import zasilkovnaWebp from '@/assets/images/transports-payments/zasilkovna.png?w=100&format=webp&as=srcset'
import zasilkovnaDomuFallback from '@/assets/images/transports-payments/zasilkovna-domu.png?w=100'
import zasilkovnaDomuAvif from '@/assets/images/transports-payments/zasilkovna-domu.png?w=100&format=avif&as=srcset'
import zasilkovnaDomuWebp from '@/assets/images/transports-payments/zasilkovna-domu.png?w=100&format=webp&as=srcset'
import klarnaFallback from '@/assets/images/transports-payments/klarna.png?w=100'
import klarnaAvif from '@/assets/images/transports-payments/klarna.png?w=100&format=avif&as=srcset'
import klarnaWebp from '@/assets/images/transports-payments/klarna.png?w=100&format=webp&as=srcset'
import paypalFallback from '@/assets/images/transports-payments/paypal.png?w=100'
import paypalAvif from '@/assets/images/transports-payments/paypal.png?w=100&format=avif&as=srcset'
import paypalWebp from '@/assets/images/transports-payments/paypal.png?w=100&format=webp&as=srcset'
import dhlFallback from '@/assets/images/transports-payments/dhl.png?w=100'
import dhlAvif from '@/assets/images/transports-payments/dhl.png?w=100&format=avif&as=srcset'
import dhlWebp from '@/assets/images/transports-payments/dhl.png?w=100&format=webp&as=srcset'
import emailFallback from '@/assets/images/transports-payments/e-mail.png?w=100'
import emailAvif from '@/assets/images/transports-payments/e-mail.png?w=100&format=avif&as=srcset'
import emailWebp from '@/assets/images/transports-payments/e-mail.png?w=100&format=webp&as=srcset'
import dhlPlFallback from '@/assets/images/transports-payments/dhl-punkt.png?w=100'
import dhlPlAvif from '@/assets/images/transports-payments/dhl-punkt.png?w=100&format=avif&as=srcset'
import dhlPlWebp from '@/assets/images/transports-payments/dhl-punkt.png?w=100&format=webp&as=srcset'
import dhlDeFallback from '@/assets/images/transports-payments/dhl-packstation.png?w=100'
import dhlDeAvif from '@/assets/images/transports-payments/dhl-packstation.png?w=100&format=avif&as=srcset'
import dhlDeWebp from '@/assets/images/transports-payments/dhl-packstation.png?w=100&format=webp&as=srcset'

export const transportImages = [
  {
    name: 'transports-payments/zasilkovna-domu.png',
    avif: zasilkovnaDomuAvif,
    webp: zasilkovnaDomuWebp,
    fallback: zasilkovnaDomuFallback,
  },
  {
    name: 'transports-payments/best_delivery_pl.png',
    avif: zasilkovnaDomuAvif,
    webp: zasilkovnaDomuWebp,
    fallback: zasilkovnaDomuFallback,
  },
  {
    name: 'transports-payments/best-delivery.png',
    avif: zasilkovnaDomuAvif,
    webp: zasilkovnaDomuWebp,
    fallback: zasilkovnaDomuFallback,
  },
  {
    name: 'transports-payments/zasilkovna.png',
    avif: zasilkovnaAvif,
    webp: zasilkovnaWebp,
    fallback: zasilkovnaFallback,
  },
  {
    name: 'transports-payments/coletăria.png',
    avif: zasilkovnaAvif,
    webp: zasilkovnaWebp,
    fallback: zasilkovnaFallback,
  },
  {
    name: 'transports-payments/csomagkuldo.png',
    avif: zasilkovnaAvif,
    webp: zasilkovnaWebp,
    fallback: zasilkovnaFallback,
  },
  {
    name: 'transports-payments/ceska-posta-balik-do-ruky.png',
    avif: ceskaPostaBalikDoRukyAvif,
    webp: ceskaPostaBalikDoRukyWebp,
    fallback: ceskaPostaBalikDoRukyFallback,
  },
  {
    name: 'transports-payments/geis.png',
    avif: geisAvif,
    webp: geisWebp,
    fallback: geisFallback,
  },
  {
    name: 'transports-payments/ppl.png',
    avif: pplAvif,
    webp: pplWebp,
    fallback: pplFallback,
  },
  {
    name: 'transports-payments/ppl-parcel-shop.png',
    avif: pplParcelShopAvif,
    webp: pplParcelShopWebp,
    fallback: pplParcelShopFallback,
  },
  {
    name: 'transports-payments/ppl-parcel-shop-SK.png',
    avif: pplParcelShopSkAvif,
    webp: pplParcelShopSkWebp,
    fallback: pplParcelShopSkFallback,
  },
  {
    name: 'transports-payments/osobni-odber.png',
    avif: osobniOdberAvif,
    webp: osobniOdberWebp,
    fallback: osobniOdberFallback,
  },
  {
    name: 'transports-payments/dhl-express.png',
    avif: dhlExpressAvif,
    webp: dhlExpressWebp,
    fallback: dhlExpressFallback,
  },
  {
    name: 'transports-payments/gls.png',
    avif: glsAvif,
    webp: glsWebp,
    fallback: glsFallback,
  },
  {
    name: 'transports-payments/gls-de.png',
    avif: glsParcelFallback,
    webp: glsParcelAvif,
    fallback: glsParcelWebp,
  },
  {
    name: 'transports-payments/gls-allindirizzo.png',
    avif: glsParcelFallback,
    webp: glsParcelAvif,
    fallback: glsParcelWebp,
  },
  {
    name: 'transports-payments/gls-punti-di-ritiro-o-presso-locker.png',
    avif: glsParcelFallback,
    webp: glsParcelAvif,
    fallback: glsParcelWebp,
  },
  {
    name: 'transports-payments/gls-parcel.png',
    avif: glsParcelFallback,
    webp: glsParcelAvif,
    fallback: glsParcelWebp,
  },
  {
    name: 'transports-payments/gls-boxy.png',
    avif: glsParcelFallback,
    webp: glsParcelAvif,
    fallback: glsParcelWebp,
  },
  {
    name: 'transports-payments/paczkomat_pl.png',
    avif: paczkomatAvif,
    webp: paczkomatWebp,
    fallback: paczkomatFallback,
  },
  {
    name: 'transports-payments/fan_courier.png',
    avif: fanCourierAvif,
    webp: fanCourierWebp,
    fallback: fanCourierFallback,
  },
  {
    name: 'transports-payments/klarna.png',
    avif: klarnaAvif,
    webp: klarnaWebp,
    fallback: klarnaFallback,
  },
  {
    name: 'transports-payments/paypal.png',
    avif: paypalAvif,
    webp: paypalWebp,
    fallback: paypalFallback,
  },
  {
    name: 'transports-payments/dhl.png',
    avif: dhlAvif,
    webp: dhlWebp,
    fallback: dhlFallback,
  },
  {
    name: 'transports-payments/dhl-punkt.png',
    avif: dhlPlAvif,
    webp: dhlPlWebp,
    fallback: dhlPlFallback,
  },
  {
    name: 'transports-payments/dhl-packstation.png',
    avif: dhlDeAvif,
    webp: dhlDeWebp,
    fallback: dhlDeFallback,
  },
  {
    name: 'transports-payments/e-mailem.png',
    avif: emailAvif,
    webp: emailWebp,
    fallback: emailFallback,
  },
  {
    name: 'transports-payments/e-mailben.png',
    avif: emailAvif,
    webp: emailWebp,
    fallback: emailFallback,
  },
  {
    name: 'transports-payments/e-mailom.png',
    avif: emailAvif,
    webp: emailWebp,
    fallback: emailFallback,
  },
  {
    name: 'transports-payments/e-mail.png',
    avif: emailAvif,
    webp: emailWebp,
    fallback: emailFallback,
  },
]
